export const RoutesPaths = {
  LANDING: "/",
  PRIVACYPOLICY: "/privacy-policy",
  TERMSCONDITIONS: "/terms-conditions",
  NOTFOUND: "/not-found",
  ACCOUNTCLOSE: "/account-close",
};
